// person duplicate search code
class HitsStorage {
	/**
	 * Class store search results and calculate result weight on store
	 */

	weights = {
		'formalName': 2,
		'nickname': 0 ,
		'lastname': 0 ,
		'userType': 1,
		'title': 0,
		'birthday': 2,
		'sex_string': 1,
		'sex_id': 1,
		'address': 0,
		'employment': 1,
		'zipcodes': 2,
		'phonenumbers': 3,
		'emails': 3
	}

	formNames = {
		'roepnaam': 'nickname',
		'achternaam': 'lastname',
		'postcode': 'zipcodes',
		'telefoonVast': 'phonenumbers',
		'emailAdres': 'emails'
	}

	indexField = 'userID'

	constructor(records, key, term) {
		this.records = {}
		this.hitScores = {}
		this.key = key
		this.term = term
		for (const rec of records) {
			this.store(rec, key, term)
		}
	}

	store(rec, key, term) {
		let uid = rec[this.indexField]
		this.records[uid] = rec
		this.hitScores[uid] = this.score(rec, key, term)
	}

	score(rec, key, term) {
		let hitScore = 0
		for (const field of Object.keys(rec["_matchesPosition"])) {
			let w = this.weights[field]
			let matchesLen = rec["_matchesPosition"][field].reduce((partsum, a) => partsum + a.length, 0)
			if (w!==undefined) {
				let w = 1
			}
			if (field === this.formNames[key] | field === key) {
				w = w+3
			}
			hitScore += w * (matchesLen / term.length)
		}
		return hitScore
	}
}

function sumMergeObject(map1, map2) {
	return Object.entries(map2).reduce((acc, [key, value]) => ({ ...acc, [key]: (acc[key] || 0) + value }), { ...map1 })
}

function mergeHiglights(matchInfo1, matchInfo2) {
	let matches = {}
	for (const field of Object.keys(matchInfo1).concat(Object.keys(matchInfo2))) {
		if (matches.hasOwnProperty(field)) {continue}
		if (matchInfo1.hasOwnProperty(field) & !matchInfo2.hasOwnProperty(field)) {
			matches[field] = matchInfo1[field]
		} else if (!matchInfo1.hasOwnProperty(field) & matchInfo2.hasOwnProperty(field)) {
			matches[field] = matchInfo2[field]
		} else {
			let v1 = matchInfo1[field]
			let v2 = matchInfo2[field]
			let m = v1.concat(v2).map(x => [x["start"], x["start"] + x["length"]]).sort((p1,p2) => p1[0] - p2[0])
			let mergedMatches = [m[0]]
			for (let i=1; i<m.length; i++) {
				let lastSegment = mergedMatches[mergedMatches.length-1]
                let newSegment = m[i]
                if (newSegment[0] > lastSegment[0]) {
                    mergedMatches.push(newSegment) // new segment does not overlap
                } else if (newSegment[1] > lastSegment[1]) { // newSegmet[0] <= last[0]
                    mergedMatches[mergedMatches.length-1][1] = newSegment[1] // segments do overlap
                } else {
                    continue // segment invalid or not sorted and should be skipped
                }
			}
			matches[field] = mergedMatches.map(x => ({start: x[0], length: x[1]-x[0]}))
		}
	}
	return matches
}

function applyHighlights(rec, terms=[]) {
	for (const field of Object.keys(rec["_matchesPosition"])) {
		let m = rec["_matchesPosition"][field].map(x => [x["start"], x["start"] + x["length"]]).sort((p1,p2) => p2[0] - p1[0])
		let formatedValue = rec[field]
        if (!(typeof formatedValue === 'string' || formatedValue instanceof String)) {
            formatedValue = formatedValue.join(", ")
        }
		for (let interval of m) {
			let className = ""
			if (terms.length > 0) {
				if (terms.includes(rec[field].slice(interval[0], interval[1]))) {
					className = ' class="exact"'
				} else {
					className = ' class="fuzzy"'
				}
			}
			formatedValue = formatedValue.slice(0, interval[1]) + "</em>" + formatedValue.slice(interval[1])
			formatedValue = formatedValue.slice(0, interval[0]) + "<em" + className + ">" + formatedValue.slice(interval[0])
		}
		rec["_formatted"][field] = formatedValue
	}
	return rec
}

class DuplicatePersonSearch {
	/* Class that manage duplicate search functionality for Person toevoegen form */
	sexDict = {0: null, 1: 'man', 2: 'vrouw', 3: 'anders'}

	nameElements = ['roepnaam', 'achternaam']

	constructor() {
		this.results = {}
		this.searchHistory = {}				// list of suggested users as full user data
		this.showResults = true
		// this.suggestion = "empty"
		this.sex = null					// string if the sex filter is set, othervise null
	}

	searchTerm(key, searchTerm) {
		/** Sending request to the server and storing the results
		 ** @param {string} key - Id if the field that triggered the search query - "achternaam", "postcode" ...
		** @param {string} searchTerm - string to search in the database
		*/
		var thisClass = this
		if (searchTerm == "") {
			delete thisClass.results[key]
			delete thisClass.searchHistory[key]
			this.updateAll()
			return
		}
		if (this.nameElements.includes(key)) {
			if (key == 'achternaam' & this.searchHistory.hasOwnProperty("roepnaam")) {
				let achternaamVal = searchTerm
				let roepnaamVal = this.searchHistory['roepnaam']
				delete thisClass.results['roepnaam']
				delete thisClass.searchHistory['roepnaam']
				this.searchTerm('formalName', achternaamVal + ", " + roepnaamVal)
			} else if ((key == 'roepnaam' &  this.searchHistory.hasOwnProperty("achternaam"))) {
				let achternaamVal = this.searchHistory['achternaam']
				let roepnaamVal = searchTerm
				delete thisClass.results['achternaam']
				delete thisClass.searchHistory['achternaam']
				this.searchTerm('formalName', achternaamVal + ", " + roepnaamVal)
			}
		}
		if (key=="geslacht") {
			this.sex = this.sexDict[searchTerm]
			this.updateAll()
			return
		}

		const formData = new FormData()
		formData.append('term', searchTerm)
		formData.append('sex', this.sex || '')
		formData.append('formated', 0)
		formData.append('highlights', 1)
		axios({
			method: "post",
			url: window.location.origin+'/regicrm/form/zoekpersoonextended',
			data: formData,
			headers: { "Content-Type": "multipart/form-data" },
		})
		.then((hits) => {
			thisClass.results[key] = new HitsStorage(hits.data, key, searchTerm)
			thisClass.searchHistory[key] = searchTerm
			thisClass.rankAndShow()
		})
	}

	rankAndShow(n=3) {
		let topResults = []
		// merge scores
		let scores = null
		for (const [key, hits] of Object.entries(this.results)) {
			if (scores === null) {
				scores = hits.hitScores
			} else {
				scores = sumMergeObject(scores, hits.hitScores)
			}
		}
		// get to scores
		let topInds = Object.entries(scores)
			.sort(
				function (a, b) {
					if (a[1] > b[1]) return -1
					if (a[1] < b[1]) return 1
					return 0
				}
			)
			.slice(0,n)
			.map(a=>a[0])

		for (const uid of topInds) {
			let res = null
			for (const key in this.results) {
				let rec = this.results[key].records[uid]
				if (rec===undefined) {continue}
				if (res === null) {
					res = rec
				} else {
					res["_matchesPosition"] = mergeHiglights(rec["_matchesPosition"], res["_matchesPosition"])
				}
			}
			topResults.push(applyHighlights(res, Object.values(this.searchHistory))["_formatted"])
		}

		Alpine.store('searchResultsStore').update(topResults)
		Alpine.store('searchResultsStore').setTopScore(scores[topInds[0]])
	}

	updateAll() {
		Alpine.store('searchResultsStore').clear()
		this.results = {}
		for (const [key, term] of Object.entries(this.searchHistory)) {
			this.searchTerm(key, term)
		}
	}
}

window.duplicateSearcher = new DuplicatePersonSearch()

// timer counting time since last input from the user
var timeout = null

window.oninputSearchTrigger = function (thisInput, submitIfNoInputForMs=1000) {
	/**
	* Function triggers the search request if there is no input for 1 second
	* @param {string} thisInput - input field instance
	* @param {integer} submitIfNoInputForMs - if no input recieved for this amount of time in ms,
	*  the field considered filled and the search request is fired up
	*/
	let key = thisInput.hasAttribute('search-key') ? thisInput.getAttribute('search-key') : thisInput.id
	if (submitIfNoInputForMs === 0) {
		window.duplicateSearcher.searchTerm(key, thisInput.value)
	} else {
		clearTimeout(timeout)
		timeout = setTimeout(
			function () {
				window.duplicateSearcher.searchTerm(key, thisInput.value)
			},
			submitIfNoInputForMs
		)
	}
}

document.addEventListener('alpine:init', ()=> {
	Alpine.data('searchResults', () => ({
		results: duplicateSearcher.results,
	}))

	Alpine.store('searchResultsStore', {
		results: [],
		topScore: 0,
		update (results) { this.results = JSON.parse(JSON.stringify(results)) },
		clear () { 
			this.results = []
			this.topScore = 0
			window.duplicateSearcher = new DuplicatePersonSearch()
		},
		setTopScore (score) { this.topScore = score },
	})
})